import { render, staticRenderFns } from "./CustomerValidationView.vue?vue&type=template&id=a9145d00"
import script from "./CustomerValidationView.vue?vue&type=script&lang=js"
export * from "./CustomerValidationView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports